import $ from 'jquery';
import fetchUrl from 'utils/fetch';
import React, { Component } from 'react';
import moment from 'moment';
import { redirectToResponse } from 'utils/redirect';
import { Modal, Form, Button } from 'semantic-ui-react';
import { storeSuccess } from 'plugins/toastr';
import * as NewsApi from 'news/api';
import { mountComponent, unmountCurrentComponent } from 'utils/modals';

export default onSubmit => {
  mountComponent(
    <PostponeModal onConfirm={onSubmit} onClose={unmountCurrentComponent} />
  );
};

export const bindInteractions = id => {
  $('#bt-update-postpone').on('click', event => bindUpdate(id, event));
  $('#bt-cancel-postpone').on('click', event => bindCancel(id, event));
};

function bindUpdate(id, event) {
  const confirm = date =>
    NewsApi.updatePostpone(id, date)
      .then(res => {
        storeSuccess('Programmation reprogrammée avec succès');
        return res;
      })
      .then(redirectToResponse);

  mountComponent(
    <PostponeModal onConfirm={confirm} onClose={unmountCurrentComponent} />
  );
}

function bindCancel(id, event) {
  const $button = $(event.currentTarget);
  const url = $button.attr('data-url');

  if (url && url.length) {
    $button.addClass('loading');

    fetchUrl(url, { method: 'DELETE' })
      .then(res => {
        storeSuccess('Programmation annulée avec succès');
        return res;
      })
      .then(redirectToResponse);
  }
}

type Props = {
  onConfirm: (value: Date) => Promise<Object>,
  onClose: () => void,
};

const minPostponeDate = () => moment().add(1, 'hours').toDate();

const formatPostponeDate = date => moment(date).format('DD/MM/YYYY HH:mm');

class PostponeModal extends Component {
  props: Props;

  constructor(props: Props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  componentDidMount() {
    $(this.calendar).calendarFr({
      minDate: minPostponeDate(),
      disableMinute: true,
      onChange: this.onDateChange,
    });
  }

  onDateChange = value => this.setState({ value });

  onConfirm = () => {
    const { value } = this.state;
    if (value) {
      const handleConfirm = () =>
        this.props.onConfirm(formatPostponeDate(value)).then(_ =>
          this.setState({
            loading: false,
          })
        );

      this.setState(
        {
          loading: true,
        },
        handleConfirm
      );
    }
  };

  render() {
    const { onClose } = this.props;
    const { value, loading } = this.state;

    return (
      <Modal size="small" closeIcon open onClose={onClose}>
        <Modal.Header>Publication ultérieure</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Field>
              <label>Date de publication</label>
              <div className="ui calendar" ref={ref => (this.calendar = ref)}>
                <div className="ui input left icon">
                  <i className="calendar icon" />
                  <input
                    type="text"
                    name="postpone"
                    placeholder="Date"
                    readOnly
                  />
                </div>
              </div>
            </Form.Field>
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose}>Annuler</Button>
          <Button
            onClick={this.onConfirm}
            disabled={value === undefined}
            loading={loading}
            positive
            icon="play"
            labelPosition="right"
            content="Programmer"
          />
        </Modal.Actions>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/news/postpone.js